require('./userProfileDirectiveController');

"use strict";

angular.module('app.userProfile.userProfileDirective', [
    'app.userProfile.userProfileDirective.userProfileDirectiveController'
])
    .directive('userProfile', [
        function () {
            return {
                restrict: 'EA',
                templateUrl: 'components/userProfile/userProfileDirective/userProfileDirectiveView.html',
                controller: 'app.userProfile.userProfileDirective.userProfileDirectiveController',
                scope: {
                    username: '<'
                }
            };
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/userProfile/userProfileDirective/userProfileDirective.js